<template>
  <div class="background-gray has-border pa-4">
    <div v-for="schedule in dataSchedule" :key="schedule.id">
      <v-row no-gutters class="mb-4">
        <v-col cols="2" class="pr-4">
          <BaseInput
            type="date"
            :rules="[$rules.required]"
            v-model="schedule.date"
            label="Ngày học"
            placeholder="dd/mm/yyyy"
            hide-details
          />
        </v-col>
        <v-col cols="2" class="pr-4">
          <BaseInput
            :rules="[$rules.required, $rules.time, $rules.rangeTime(schedule.endTime)]"
            v-model="schedule.startTime"
            append-icon="mdi-clock-outline"
            label="Giờ bắt đầu"
            placeholder="Chọn giờ bắt đầu"
            hide-details
          />
        </v-col>
        <v-col cols="2" class="pr-4">
          <BaseInput
            :rules="[$rules.required, $rules.time]"
            v-model="schedule.endTime"
            append-icon="mdi-clock-outline"
            label="Giờ kết thúc"
            placeholder="Chọn giờ kết thúc"
            hide-details
          />
        </v-col>
        <v-col class="pr-4">
          <AutocompleteClassroom
            v-model="schedule.classroom"
            clear-icon="mdi-close"
            label="Phòng học"
            outlined
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-btn @click="$emit('delete', schedule)" icon color="red">
            <v-icon>mdi-delete-forever</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-divider class="my-4" />
      <BaseButton
        icon="mdi-plus"
        isButtonText
        :text="$vuetify.lang.t('Thêm lịch')"
        @click="$emit('create')"
        class="px-0"
      />
      <UploadExcelForFreeSchedule @upload-schedules="handleUploadedSchedules" />
    </div>
  </div>
</template>
<script>
import BaseInput from '../../../components/basic/BaseInput.vue'
import BaseButton from '../../../components/basic/BaseButton.vue'
import AutocompleteClassroom from '@/components/basic/input/AutocompleteClassroom.vue'
import UploadExcelForFreeSchedule from './UploadExcelForFreeSchedule.vue'
import moment from 'moment'
import uuid from 'uuid'

export default {
  components: {
    BaseInput,
    BaseButton,
    AutocompleteClassroom,
    UploadExcelForFreeSchedule,
  },
  props: {
    schedules: Array,
    isAllInputDisabled: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    let val = [...this.schedules]
    if (Array.isArray(val) && val.length) {
      this.dataSchedule = val.sort((a, b) => moment(a.date) - moment(b.date))
    }
  },
  data() {
    return {
      dataSchedule: [],
    }
  },
  watch: {
    schedules: {
      handler(val) {
        if (Array.isArray(val)) {
          this.dataSchedule = [...val]
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleUploadedSchedules(schedules) {
      const newSchedules = schedules.map((schedule) => ({
        ...schedule,
        id: 'new_' + uuid.v4(),
        type: 'free-schedule',
      }))
      this.dataSchedule = [...this.dataSchedule, ...newSchedules].sort((a, b) => moment(a.date) - moment(b.date))
      this.$emit('update:schedules', this.dataSchedule)
    },
  },
}
</script>
